<template>
  <div>
    <div class="ship-wrp">
        <div class="item" v-for="(item, idx) in shopCatList" :key="idx">
            <div class="shopname">
                <img :src="item.icon" />
                <span :title="item.name">{{ item.name }}</span>
            </div>
            <el-cascader
                :ref="`cascader_${item.shopId}`"
                width="200px"
                :loading="selectLoading"
                :value="item.tbShopCat"
                :options="catMaps[item.shopId] || []"
                :props="catPrpos"
                :show-all-levels="false"
                placeholder="请选择店铺分类"
                showTags
                collapse-tags
                @visible-change="visibleSelectCat(item)"
                @change="v => catChange(v, item)"
            ></el-cascader>
            <div class="ml-10"><el-link class="no-border" @click="visibleSelectCat(item, true)">刷新</el-link></div>
        </div>
    </div>
    <!-- <div style="font-size: 12px">
        最多支持选择10项分类，<el-link href="https://siteadmin.taobao.com/category/index.htm" target="_blank">查看店铺分类</el-link>
    </div> -->
  </div>
</template>

<script>
import storeMixins from '../store-mixins';
import { getTaobaoSellerCatsGet } from '@api/prod/conf/index.js';
export default {
  mixins: [storeMixins],
  props: {
    shopList:{
        type: Array,
        default: () => []
    }
  },
  data(){
    return {
        catPrpos: {
            value: 'cid',
            label: 'name',
            multiple: true,
            emitPath: false,
        },
        selectLoading: false,
        catMaps: {},
        shopCatList:[],
        selectCat:{},
        isRequestCatsMap:{},
    }
  },
  computed: {},
  created(){
    let shopCatConfig = this.tbForm.shopCatConfig || '{}'
    shopCatConfig = JSON.parse(shopCatConfig)
    this.shopCatList = this.shopList.map(item => {
       let tbShopCat = (shopCatConfig[item.id] || []).map(i => i.id)
        return {
            icon: item.icon,
            shopId: item.id,
            name:item.shortTitle || item.title,
            tbShopCat:tbShopCat
        }
    });
    // 根据保存的值生成默认下拉列表
    for(let shopId in shopCatConfig){
      let list = shopCatConfig[shopId];
      list= list.map(i => ({
        name: i.name.split('>').pop(),
        cid: i.id
      }));
      this.$set(this.catMaps,shopId,list)
    }
  },
  methods: {
    // 查询店铺分类列表
    async visibleSelectCat(item, forceUpdate) {
      const { shopId } = item;
      if (!forceUpdate && this.catMaps[shopId] && this.isRequestCatsMap[shopId]) return;
      const res = await getTaobaoSellerCatsGet({ shopId });
      this.isRequestCatsMap[shopId] = true;
      const list = res.data || [];
      this.$set(this.catMaps, shopId, list);
    },
    catChange(v, item) {
      item.tbShopCat = v;
      let shopId = item.shopId
      let ref = 'cascader_'+shopId
      let checkedNodes = this.$refs[ref][0].getCheckedNodes();
      let nodesMap = {}
      let checkList = [];
      checkedNodes.forEach(item => {
        nodesMap[item.value] = item.pathLabels.join('>');
      });
      v.forEach(id => {
        checkList.push({
          name:nodesMap[id],
          id
        })
      });
      this.selectCat[shopId] = checkList;
      if(checkList.length){
        this.selectCat[shopId] = checkList;
      }else{
        delete this.selectCat[shopId];
      }
      let shopCatConfig = JSON.stringify(this.selectCat)
      this.updateTbForm({
        shopCatConfig:shopCatConfig !== '{}' ? shopCatConfig : null
      })
    },
  }
};
</script>

<style lang="scss" scoped>
  .ship-wrp {
    margin-left: 5px;
    .item {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 20px;
      .shopname {
        width: 150px;
        display: flex;
        img {
          width: 26px;
          height: 26px;
          border-radius: 50%;
          vertical-align: middle;
        }
        span {
          font-size: 12px;
          vertical-align: middle;
          display: inline-block;
          margin-left: 10px;
          color: #606266;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }
  }
</style>